module.exports = __webpack_public_path__ + "media/images/flags/4x3/egy-0621dac241f2963dce830c4c741f515d.svg";